import { useState } from 'react';
import styled from 'styled-components';
import { useMeasure } from '@frameio/vapor';
import { fadeInLeftShadow, fadeOutLeftShadow } from './shadows';

// @todo (ASSETS-1230): remove all usages of this component in favor on HorizontalScrollingContainer

type ScrollingJobProps = {
  className?: string;
  children: any;
};

const shadowWidth = 16;

function Component({ className, children }: ScrollingJobProps) {
  const [containerRef, containerRect] = useMeasure();
  const [contentRef, contentRect] = useMeasure();
  const [xOffset, setXOffset] = useState(0);
  const overflowX = contentRect?.width - containerRect?.width;

  return (
    <span
      ref={containerRef}
      className={`job-size ${className} ${overflowX > 0 ? 'overflow' : ''}`}
      onMouseEnter={() => {
        if (overflowX) setXOffset(overflowX + shadowWidth);
      }}
      onMouseLeave={() => {
        if (overflowX) setXOffset(0);
      }}
    >
      <span
        ref={contentRef}
        className="content"
        style={{
          transform: `translateX(-${xOffset}px)`,
        }}
      >
        {children}
      </span>
    </span>
  );
}

/**
 * Shows the upload progress in terms of number of files and bytes.
 *
 * When text overflows the container, the overflowed text is hidden until
 * hovered, when it is transitions in.
 */
export const ScrollingJob = styled(Component)`
  display: inline-block;
  overflow: hidden;
  position: relative;

  .content {
    > * {
      display: inline-block;
      vertical-align: middle;
    }
    display: inline-block;
  }

  &.overflow {
    &:before {
      ${fadeOutLeftShadow(`${shadowWidth}px`)};
      opacity: 0;

      transition: opacity 0.3s ease;
      z-index: 1;
    }
    &:after {
      ${fadeInLeftShadow(`${shadowWidth}px`)};
    }

    &:hover :before {
      opacity: 1;
    }

    .content {
      transition: transform 0.5s linear;
    }
  }
`;
